export default "__VITE_ASSET__Dxx56oHS__"